document.addEventListener('DOMContentLoaded', () => {
  const filterButtons = document.querySelectorAll('.filter-button');
  const filterDrawers = document.querySelectorAll('.filter-drawer');
  const filterDrawerBackdrops = document.querySelectorAll('.filter-drawer-backdrop');
  const filterDrawerContents = document.querySelectorAll('.filter-drawer-content');
  const filterDrawerCloses = document.querySelectorAll('.filter-drawer-close');
  const filterIndicatorIcons = document.querySelectorAll('.filter-indicator-icon');

  const filterDrawer = filterDrawers[0];
  const filterDrawerBackdrop = filterDrawerBackdrops[0];
  const filterDrawerContent = filterDrawerContents[0];

  if (!filterDrawer || !filterDrawerBackdrop || !filterDrawerContent) return;

  function getSubCollectionHandles() {
    const collectionTabs = document.querySelectorAll('.collection-tab-item[data-collection-handle]');
    const collectionHandles = [];
    collectionTabs.forEach(collectionTab => {
      const collectionHandle = collectionTab.getAttribute('data-collection-handle');
      if (collectionHandle && collectionHandle !== 'all') {
        collectionHandles.push(collectionHandle);
      }
    });
    return collectionHandles;
  }

  async function fetchCollectionFilters(collectionHandle) {
    try {
      const sectionId = 'collection-filters';
      const url = new URL(`/collections/${collectionHandle}`, window.location.origin);
      url.searchParams.set('sections', sectionId);

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.forEach((value, key) => {
        if (key.startsWith('filter.')) {
          url.searchParams.append(key, value);
        }
      });

      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const sectionHtml = data[sectionId] || '';
      if (!sectionHtml) {
        return null;
      }
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      return doc.body;
    } catch (error) {
      console.error(`Error fetching filters for ${collectionHandle}:`, error);
      return null;
    }
  }

  async function aggregateSubCollectionFilters() {
    const collectionHandles = getSubCollectionHandles();
    if (collectionHandles.length === 0) {
      return null;
    }

    const allFilterDocuments = await Promise.all(
      collectionHandles.map(collectionHandle => fetchCollectionFilters(collectionHandle))
    );

    const validFilterDocuments = allFilterDocuments.filter(filterDocument => filterDocument !== null);
    if (validFilterDocuments.length === 0) {
      return null;
    }

    const aggregatedContainer = document.createElement('div');
    const filterGroupsMap = new Map();

    validFilterDocuments.forEach((filterDocument) => {
      const filterGroups = filterDocument.querySelectorAll('.filter-group[data-filter-type]');
      filterGroups.forEach(filterGroup => {
        const filterType = filterGroup.getAttribute('data-filter-type');

        if (filterType === 'availability' || filterType === 'price') {
          return;
        }

        const clonedFilterGroup = filterGroup.cloneNode(true);

        if (filterType === 'size') {
          if (!filterGroupsMap.has(filterType)) {
            const sizeHandlesMap = new Map();
            const filterCheckboxes = clonedFilterGroup.querySelectorAll('.size-filter-checkbox');
            filterCheckboxes.forEach(filterCheckbox => {
              const sizeHandle = filterCheckbox.getAttribute('data-size-collection-handle');
              if (sizeHandle) {
                sizeHandlesMap.set(sizeHandle, true);
              }
            });

            filterGroupsMap.set(filterType, {
              element: clonedFilterGroup,
              values: sizeHandlesMap
            });
            return;
          }

          const existingFilterGroup = filterGroupsMap.get(filterType);
          const accordionContent = existingFilterGroup.element.querySelector('[data-accordion-content]');
          const accordionContentInner = accordionContent?.querySelector('.accordion__content-inner');
          const existingFilterContainer = accordionContentInner?.querySelector('label .size-filter-checkbox')?.closest('label')?.parentElement ||
            existingFilterGroup.element.querySelector('label .size-filter-checkbox')?.closest('label')?.parentElement ||
            accordionContentInner ||
            existingFilterGroup.element.querySelector('.filter-group > div');

          const filterCheckboxes = clonedFilterGroup.querySelectorAll('.size-filter-checkbox');
          filterCheckboxes.forEach(filterCheckbox => {
            const sizeHandle = filterCheckbox.getAttribute('data-size-collection-handle');
            if (!sizeHandle) return;

            const filterLabel = filterCheckbox.closest('label');

            if (existingFilterGroup.values.has(sizeHandle)) {
              const existingFilterCheckbox = existingFilterGroup.element.querySelector(`[data-size-collection-handle="${sizeHandle}"]`);
              if (existingFilterCheckbox && (filterCheckbox.checked || existingFilterCheckbox.checked)) {
                existingFilterCheckbox.checked = true;
              }
              return;
            }

            existingFilterGroup.values.set(sizeHandle, true);
            if (!(existingFilterContainer && filterLabel)) {
              return;
            }
            const clonedFilterLabel = filterLabel.cloneNode(true);
            const clonedFilterCheckbox = clonedFilterLabel.querySelector('.size-filter-checkbox');
            if (clonedFilterCheckbox && filterCheckbox.checked) {
              clonedFilterCheckbox.checked = true;
            }
            existingFilterContainer.appendChild(clonedFilterLabel);
          });
          return;
        }

        if (!filterGroupsMap.has(filterType)) {
          const filterValuesMap = new Map();
          const filterCheckboxes = clonedFilterGroup.querySelectorAll('.filter-checkbox');
          filterCheckboxes.forEach(filterCheckbox => {
            const filterValue = filterCheckbox.getAttribute('data-filter-value');
            const filterCount = parseInt(filterCheckbox.getAttribute('data-filter-count')) || 0;
            filterValuesMap.set(filterValue, filterCount);
          });

          filterGroupsMap.set(filterType, {
            element: clonedFilterGroup,
            values: filterValuesMap
          });
          return;
        }
        const existingFilterGroup = filterGroupsMap.get(filterType);
        const accordionContent = existingFilterGroup.element.querySelector('[data-accordion-content]');
        const accordionContentInner = accordionContent?.querySelector('.accordion__content-inner');
        const existingFilterContainer = accordionContentInner?.querySelector('[data-ungrouped-container] .color-swatches-wrapper') ||
          accordionContentInner?.querySelector('[data-ungrouped-container]') ||
          accordionContentInner?.querySelector('label .filter-checkbox')?.closest('label')?.parentElement ||
          existingFilterGroup.element.querySelector('label .filter-checkbox')?.closest('label')?.parentElement ||
          accordionContentInner ||
          existingFilterGroup.element.querySelector('.filter-group > div');

        const filterCheckboxes = clonedFilterGroup.querySelectorAll('.filter-checkbox');
        filterCheckboxes.forEach(filterCheckbox => {
          const filterValue = filterCheckbox.getAttribute('data-filter-value');
          const filterCount = parseInt(filterCheckbox.getAttribute('data-filter-count')) || 0;
          const filterLabel = filterCheckbox.closest('label');

          if (existingFilterGroup.values.has(filterValue)) {
            const existingFilterCount = existingFilterGroup.values.get(filterValue);
            const aggregatedFilterCount = existingFilterCount + filterCount;
            existingFilterGroup.values.set(filterValue, aggregatedFilterCount);

            const existingFilterCheckbox = existingFilterGroup.element.querySelector(`[data-filter-value="${filterValue}"]`);
            if (existingFilterCheckbox) {
              existingFilterCheckbox.setAttribute('data-filter-count', aggregatedFilterCount);
              if (filterCheckbox.checked || existingFilterCheckbox.checked) {
                existingFilterCheckbox.checked = true;
              }
              const existingFilterLabel = existingFilterCheckbox.closest('label');
              if (existingFilterLabel) {
                const countSpan = existingFilterLabel.querySelector('.filter-count');
                if (countSpan) {
                  countSpan.textContent = `(${aggregatedFilterCount})`;
                }
              }
            }
            return;
          }
          existingFilterGroup.values.set(filterValue, filterCount);
          if (!filterLabel) return;

          const clonedFilterLabel = filterLabel.cloneNode(true);
          const clonedFilterCheckbox = clonedFilterLabel.querySelector('.filter-checkbox');
          if (clonedFilterCheckbox && filterCheckbox.checked) {
            clonedFilterCheckbox.checked = true;
          }

          if (!existingFilterContainer) return;
          existingFilterContainer.appendChild(clonedFilterLabel);

          const parentGroupHandle = filterCheckbox.getAttribute('data-parent-group');
          if (parentGroupHandle) {
            const parentSwatchCheckbox = existingFilterGroup.element.querySelector(
              `.color-parent-swatch-checkbox[data-parent-group-handle="${parentGroupHandle}"]`
            );
            const parentSwatchLabel = parentSwatchCheckbox?.closest('label');
            if (parentSwatchLabel && parentSwatchLabel.classList.contains('hidden')) {
              parentSwatchLabel.classList.remove('hidden');
            }
          }
        });
      });
    });

    filterGroupsMap.forEach(({ element }) => {
      aggregatedContainer.appendChild(element);
    });

    return aggregatedContainer;
  }

  let lastFilterState = null;
  let subCollectionFiltersAggregated = false;
  let isLoadingFilters = false;

  function getCurrentFilterState() {
    const url = new URL(window.location.href);
    const filterParams = new URLSearchParams();

    url.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'size_collections') {
        filterParams.append(key, value);
      }
    });

    return Array.from(filterParams.entries())
      .sort(([a], [b]) => a.localeCompare(b))
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
  }

  function hasActiveFilters() {
    const filterState = getCurrentFilterState();
    return filterState && filterState.length > 0;
  }

  function updateFilterIndicator() {
    const hasFilters = hasActiveFilters();

    requestAnimationFrame(() => {
      filterIndicatorIcons.forEach(icon => {
        if (hasFilters) {
          icon.classList.remove('hidden');
        } else {
          icon.classList.add('hidden');
        }
      });
    });
  }

  const filterContainer = document.querySelector('.filter-aggregated-content');
  if (filterContainer) {
    lastFilterState = getCurrentFilterState() || '';
  }

  // Initialize filter indicator on page load
  updateFilterIndicator();

  function hasFiltersChanged() {
    const currentState = getCurrentFilterState() || '';
    const lastState = lastFilterState || '';
    return currentState !== lastState;
  }

  function loadAggregatedFilters(forceReload = false) {
    const loadingOverlay = document.querySelector('.filter-loading-overlay');
    const filterContainer = document.querySelector('.filter-aggregated-content');

    if (!filterContainer) return;

    if (isLoadingFilters) return;

    const collectionHandles = getSubCollectionHandles();

    if (collectionHandles.length === 0) {
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
        loadingOverlay.classList.remove('flex', 'items-center', 'justify-center');
      }
      return;
    }

    const isAggregated = filterContainer.getAttribute('data-sub-collection-filters-aggregated') === 'true';
    const filtersChanged = hasFiltersChanged();

    if (isAggregated && !forceReload && !filtersChanged) {
      subCollectionFiltersAggregated = true;
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
        loadingOverlay.classList.remove('flex', 'items-center', 'justify-center');
      }
      return;
    }

    isLoadingFilters = true;

    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden');
      loadingOverlay.classList.add('flex', 'items-center', 'justify-center');
    }

    aggregateSubCollectionFilters().then(aggregatedContainer => {
      lastFilterState = getCurrentFilterState();

      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
        loadingOverlay.classList.remove('flex');
      }

      if (aggregatedContainer && aggregatedContainer.children.length > 0) {
        filterContainer.innerHTML = '';
        while (aggregatedContainer.firstChild) {
          filterContainer.appendChild(aggregatedContainer.firstChild);
        }
        initializeSizeFilterCheckboxes();
        initializeFiltersFromURL();

        subCollectionFiltersAggregated = true;
        filterContainer.setAttribute('data-sub-collection-filters-aggregated', 'true');

        window.initAccordions?.();
      } else {
        subCollectionFiltersAggregated = false;
        filterContainer.removeAttribute('data-sub-collection-filters-aggregated');
      }

      const toggleSwitches = filterContainer.querySelectorAll('.filter-checkbox-toggle');
      toggleSwitches.forEach(filterToggle => {
        const toggleSwitchElement = filterToggle.nextElementSibling;
        const toggleDot = toggleSwitchElement?.querySelector('.toggle-dot');

        function updateToggle() {
          if (filterToggle.checked) {
            toggleSwitchElement?.classList.remove('bg-gray-300');
            toggleSwitchElement?.classList.add('bg-black');
            toggleDot?.classList.remove('translate-x-0');
            toggleDot?.classList.add('translate-x-5');
            return;
          }
          toggleSwitchElement?.classList.remove('bg-black');
          toggleSwitchElement?.classList.add('bg-gray-300');
          toggleDot?.classList.remove('translate-x-5');
          toggleDot?.classList.add('translate-x-0');
        }

        updateToggle();
        filterToggle.addEventListener('change', updateToggle);
      });

      const colorFilterCheckboxes = filterContainer.querySelectorAll('.color-filter-checkbox');
      colorFilterCheckboxes.forEach(colorCheckbox => {
        const colorSwatch = colorCheckbox.nextElementSibling;
        const swatchDot = colorSwatch?.querySelector('.swatch-color');

        function updateColorSwatch() {
          if (colorCheckbox.checked) {
            colorSwatch?.classList.add('active');
            swatchDot?.classList.remove('opacity-0');
            swatchDot?.classList.add('opacity-100');
          } else {
            colorSwatch?.classList.remove('active');
            swatchDot?.classList.remove('opacity-100');
            swatchDot?.classList.add('opacity-0');
          }
        }

        updateColorSwatch();
        colorCheckbox.addEventListener('change', updateColorSwatch);
      });

      filterContainer.querySelectorAll('.color-parent-swatch-checkbox').forEach(parentSwatch => {
        updateParentSwatchVisual(parentSwatch);
        parentSwatch.addEventListener('change', () => updateParentSwatchVisual(parentSwatch));
      });

      isLoadingFilters = false;
    }).catch(error => {
      console.error('Error loading aggregated filters:', error);
      subCollectionFiltersAggregated = false;
      filterContainer.removeAttribute('data-sub-collection-filters-aggregated');
      isLoadingFilters = false;
      if (loadingOverlay) {
        loadingOverlay.classList.add('hidden');
        loadingOverlay.classList.remove('flex');
      }
    });
  }

  let closeDrawerTimeoutId = null;

  function openDrawer() {
    if (closeDrawerTimeoutId !== null) {
      clearTimeout(closeDrawerTimeoutId);
      closeDrawerTimeoutId = null;
    }

    requestAnimationFrame(() => {
      filterDrawers.forEach(drawer => drawer.classList.remove('pointer-events-none'));
      filterDrawerBackdrops.forEach(backdrop => {
        backdrop.classList.remove('opacity-0');
        backdrop.classList.add('opacity-100');
      });
      filterDrawerContents.forEach(content => {
        content.classList.remove('invisible', 'translate-y-full', 'lg:translate-x-full');
        content.classList.add('translate-y-0', 'lg:translate-x-0');
      });
      document.body.classList.add('overflow-hidden');

      const loadingOverlay = document.querySelector('.filter-loading-overlay');
      if (loadingOverlay) {
        loadingOverlay.classList.remove('hidden');
        loadingOverlay.classList.add('flex', 'items-center', 'justify-center');
      }

      loadAggregatedFilters();
    });
  }

  function closeDrawer() {
    requestAnimationFrame(() => {
      filterDrawerBackdrops.forEach(backdrop => {
        backdrop.classList.remove('opacity-100');
        backdrop.classList.add('opacity-0');
      });
      filterDrawerContents.forEach(content => {
        content.classList.remove('translate-y-0', 'lg:translate-x-0');
        content.classList.add('translate-y-full', 'lg:translate-x-full');
      });

      closeDrawerTimeoutId = setTimeout(() => {
        closeDrawerTimeoutId = null;
        filterDrawers.forEach(drawer => drawer.classList.add('pointer-events-none'));
        filterDrawerContents.forEach(content => content.classList.add('invisible'));
        document.body.classList.remove('overflow-hidden');
      }, 300);
    });
  }

  filterButtons.forEach(filterButton => {
    filterButton.addEventListener('click', (e) => {
      e.stopPropagation();
      openDrawer();
    });
  });

  filterDrawerCloses.forEach(closeButton => {
    closeButton.addEventListener('click', closeDrawer);
  });

  filterDrawerBackdrops.forEach(backdrop => {
    backdrop.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && filterDrawers.length > 0 && !filterDrawers[0].classList.contains('pointer-events-none')) {
      closeDrawer();
    }
  });

  const toggleSwitches = document.querySelectorAll('.filter-checkbox-toggle');
  toggleSwitches.forEach(filterToggle => {
    const toggleSwitchElement = filterToggle.nextElementSibling;
    const toggleDot = toggleSwitchElement?.querySelector('.toggle-dot');

    function updateToggle() {
      if (filterToggle.checked) {
        toggleSwitchElement?.classList.remove('bg-gray-300');
        toggleSwitchElement?.classList.add('bg-black');
        toggleDot?.classList.remove('translate-x-0');
        toggleDot?.classList.add('translate-x-5');
        return;
      }
      toggleSwitchElement?.classList.remove('bg-black');
      toggleSwitchElement?.classList.add('bg-gray-300');
      toggleDot?.classList.remove('translate-x-5');
      toggleDot?.classList.add('translate-x-0');
    }

    updateToggle();
    filterToggle.addEventListener('change', updateToggle);
  });

  const colorFilterCheckboxes = document.querySelectorAll('.color-filter-checkbox');
  colorFilterCheckboxes.forEach(colorCheckbox => {
    const colorSwatch = colorCheckbox.nextElementSibling;
    const swatchDot = colorSwatch?.querySelector('.swatch-color');

    function updateColorSwatch() {
      if (colorCheckbox.checked) {
        colorSwatch?.classList.add('active');
        swatchDot?.classList.remove('opacity-0');
        swatchDot?.classList.add('opacity-100');
      } else {
        colorSwatch?.classList.remove('active');
        swatchDot?.classList.remove('opacity-100');
        swatchDot?.classList.add('opacity-0');
      }
    }

    updateColorSwatch();
    colorCheckbox.addEventListener('change', updateColorSwatch);
  });

  document.querySelectorAll('.color-parent-swatch-checkbox').forEach(parentSwatch => {
    updateParentSwatchVisual(parentSwatch);
    parentSwatch.addEventListener('change', () => updateParentSwatchVisual(parentSwatch));
  });

  function initializeSizeFilterCheckboxes() {
    const sizeFilterCheckboxes = document.querySelectorAll('.size-filter-checkbox');
    sizeFilterCheckboxes.forEach(sizeCheckbox => {
      const customCheckbox = sizeCheckbox.nextElementSibling;
      const checkIcon = customCheckbox?.querySelector('.size-filter-check');

      function updateSizeCheckbox() {
        if (sizeCheckbox.checked) {
          customCheckbox?.classList.remove('border-gray-300');
          customCheckbox?.classList.add('border-black', 'bg-black');
          checkIcon?.classList.remove('hidden');
          return;
        }
        customCheckbox?.classList.remove('border-black', 'bg-black');
        customCheckbox?.classList.add('border-gray-300');
        checkIcon?.classList.add('hidden');
      }

      updateSizeCheckbox();
      sizeCheckbox.removeEventListener('change', updateSizeCheckbox);
      sizeCheckbox.addEventListener('change', updateSizeCheckbox);
    });
  }

  function initializeFiltersFromURL() {
    const urlParams = new URLSearchParams(window.location.search);

    // Initialize size filter checkboxes from URL
    const sizeCollectionsParam = urlParams.get('size_collections');
    if (sizeCollectionsParam) {
      const sizeHandles = sizeCollectionsParam.split(',');
      sizeHandles.forEach(handle => {
        const cleanHandle = handle.trim();
        if (cleanHandle) {
          const sizeCheckbox = document.querySelector(
            `.size-filter-checkbox[data-size-collection-handle="${cleanHandle}"]`
          );
          if (sizeCheckbox) {
            sizeCheckbox.checked = true;
            const customCheckbox = sizeCheckbox.nextElementSibling;
            const checkIcon = customCheckbox?.querySelector('.size-filter-check');
            if (customCheckbox) {
              customCheckbox.classList.remove('border-gray-300');
              customCheckbox.classList.add('border-black', 'bg-black');
            }
            if (checkIcon) {
              checkIcon.classList.remove('hidden');
            }
          }
        }
      });
    }

    // Initialize parent group swatches from URL
    document.querySelectorAll('.color-parent-swatch-checkbox').forEach(parentSwatch => {
      const parentGroupHandle = parentSwatch.getAttribute('data-parent-group-handle');
      if (!parentGroupHandle) return;
      let isActive = false;
      document.querySelectorAll(`.color-filter-checkbox[data-parent-group="${parentGroupHandle}"]`).forEach(cb => {
        const filterParam = cb.getAttribute('data-filter-param');
        const filterValue = cb.getAttribute('data-filter-value');
        urlParams.forEach((urlValue, urlKey) => {
          if (urlKey === filterParam && urlValue === filterValue) isActive = true;
        });
      });
      if (isActive) {
        parentSwatch.checked = true;
        updateParentSwatchVisual(parentSwatch);
      }
    });

    // Initialize availability filter toggle from URL
    const availabilityParam = urlParams.get('filter.v.availability');
    if (availabilityParam === '1') {
      const availabilityToggle = document.querySelector(
        '.filter-checkbox-toggle[data-filter-type="availability"]'
      );
      if (availabilityToggle) {
        availabilityToggle.checked = true;
        const toggleSwitchElement = availabilityToggle.nextElementSibling;
        const toggleDot = toggleSwitchElement?.querySelector('.toggle-dot');
        if (toggleSwitchElement) {
          toggleSwitchElement.classList.remove('bg-gray-300');
          toggleSwitchElement.classList.add('bg-black');
        }
        if (toggleDot) {
          toggleDot.classList.remove('translate-x-0');
          toggleDot.classList.add('translate-x-5');
        }
      }
    }
  }

  initializeSizeFilterCheckboxes();

  function updateParentSwatchVisual(parentSwatch) {
    const swatch = parentSwatch.nextElementSibling;
    const dot = swatch?.querySelector('.swatch-color');
    const parentGroupHandle = parentSwatch.getAttribute('data-parent-group-handle');

    if (parentGroupHandle) {
      document.querySelectorAll(`.color-filter-checkbox[data-parent-group="${parentGroupHandle}"]`).forEach(cb => {
        cb.checked = parentSwatch.checked;
      });
    }

    if (parentSwatch.checked) {
      swatch?.classList.add('active');
      dot?.classList.remove('opacity-0');
      dot?.classList.add('opacity-100');
    } else {
      swatch?.classList.remove('active');
      dot?.classList.remove('opacity-100');
      dot?.classList.add('opacity-0');
    }
  }

  function buildFilterParams() {
    const filterParams = new URLSearchParams();
    const seenFilterValues = new Set();

    const checkedFilterBoxes = document.querySelectorAll('.filter-checkbox:checked, .filter-checkbox-toggle:checked');
    checkedFilterBoxes.forEach(filterCheckbox => {
      const filterParam = filterCheckbox.getAttribute('data-filter-param');
      const filterValue = filterCheckbox.getAttribute('data-filter-value');
      if (filterParam && filterValue) {
        const dedupeKey = `${filterParam}::${filterValue}`;
        if (!seenFilterValues.has(dedupeKey)) {
          seenFilterValues.add(dedupeKey);
          filterParams.append(filterParam, filterValue);
        }
      }
    });

    // Handle Size filter separately
    const checkedSizeFilters = document.querySelectorAll('.size-filter-checkbox:checked');
    if (checkedSizeFilters.length > 0) {
      const sizeHandles = Array.from(checkedSizeFilters).map(checkbox => {
        return checkbox.getAttribute('data-size-collection-handle');
      }).filter(handle => handle).join(',');

      if (sizeHandles) {
        filterParams.set('size_collections', sizeHandles);
      }
    }

    return filterParams;
  }

  async function applyFilters() {
    const filterParams = buildFilterParams();
    const productGrids = document.querySelectorAll('.collection-product-grid[data-collection-handle]');

    if (productGrids.length === 0) {
      closeDrawer();
      return;
    }

    const currentUrl = new URL(window.location.href);
    const activeCollectionHandle = currentUrl.searchParams.get('tab') || 'all';

    const originalGridContents = new Map();
    requestAnimationFrame(() => {
      productGrids.forEach(productGrid => {
        originalGridContents.set(productGrid, productGrid.innerHTML);
        productGrid.classList.add('opacity-50', 'pointer-events-none');
      });
    });

    const sectionId = 'collection-product-grid';
    const filterPromises = Array.from(productGrids).map(async (productGrid) => {
      const collectionHandle = productGrid.getAttribute('data-collection-handle');
      if (!collectionHandle) return;

      try {
        const gridCurrentUrl = new URL(window.location.href);
        const currentSort = gridCurrentUrl.searchParams.get('sort_by') || 'manual';
        const subCollectionUrl = new URL(`/collections/${collectionHandle}`, window.location.origin);
        subCollectionUrl.searchParams.set('sort_by', currentSort);
        subCollectionUrl.searchParams.set('sections', sectionId);

        filterParams.forEach((filterValue, filterKey) => {
          subCollectionUrl.searchParams.append(filterKey, filterValue);
        });

        const response = await fetch(subCollectionUrl.toString());
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();
        const sectionHTML = responseData[sectionId] || '';

        if (!sectionHTML) {
          throw new Error('No section data returned');
        }

        const domParser = new DOMParser();
        const filterDocument = domParser.parseFromString(sectionHTML, 'text/html');

        // Try to find the grid - it might be in a sub-collection structure or direct
        let filteredProductGrid = filterDocument.querySelector(
          `.collection-product-grid[data-collection-handle="${collectionHandle}"]`
        );

        // If not found, try finding it within collection-product-grid-item wrapper
        if (!filteredProductGrid) {
          const gridItem = filterDocument.querySelector('.collection-product-grid-item');
          if (gridItem) {
            filteredProductGrid = gridItem.querySelector(
              `.collection-product-grid[data-collection-handle="${collectionHandle}"]`
            );
          }
        }

        if (!filteredProductGrid) {
          const allGrids = filterDocument.querySelectorAll('.collection-product-grid[data-collection-handle]');
          allGrids.forEach(grid => {
            if (grid.getAttribute('data-collection-handle') === collectionHandle) {
              filteredProductGrid = grid;
            }
          });
        }

        if (filteredProductGrid) {
          requestAnimationFrame(() => {
            productGrid.setAttribute(
              'data-has-products',
              filteredProductGrid.getAttribute('data-has-products') || 'false'
            );

            productGrid.innerHTML = filteredProductGrid.innerHTML;

            if (typeof window.initializeProductCardVariants === 'function') {
              window.initializeProductCardVariants(productGrid);
            }
          });
        } else {
          console.warn(`Could not find filtered grid for collection: ${collectionHandle}`);
          const originalGridContent = originalGridContents.get(productGrid);
          if (originalGridContent) {
            requestAnimationFrame(() => {
              productGrid.innerHTML = originalGridContent;
            });
          }
        }
      } catch (error) {
        console.error(`Error filtering collection ${collectionHandle}:`, error);
        const originalGridContent = originalGridContents.get(productGrid);
        if (originalGridContent) {
          requestAnimationFrame(() => {
            productGrid.innerHTML = originalGridContent;
            if (typeof window.initializeProductCardVariants === 'function') {
              window.initializeProductCardVariants(productGrid);
            }
          });
        }
      }
    });

    try {
      await Promise.all(filterPromises);

      requestAnimationFrame(() => {
        const currentUrl = new URL(window.location.href);

        Array.from(currentUrl.searchParams.keys()).forEach(filterKey => {
          if (filterKey.startsWith('filter.') || filterKey === 'size_collections') {
            currentUrl.searchParams.delete(filterKey);
          }
        });

        filterParams.forEach((filterValue, filterKey) => {
          currentUrl.searchParams.append(filterKey, filterValue);
        });

        if (activeCollectionHandle && activeCollectionHandle !== 'all') {
          currentUrl.searchParams.set('tab', activeCollectionHandle);
        } else {
          currentUrl.searchParams.delete('tab');
        }

        window.history.pushState({}, '', currentUrl.toString());

        productGrids.forEach(productGrid => {
          productGrid.classList.remove('opacity-50', 'pointer-events-none');
        });

        lastFilterState = getCurrentFilterState();
        subCollectionFiltersAggregated = false;
        const filterContainer = document.querySelector('.filter-aggregated-content');
        if (filterContainer) {
          filterContainer.removeAttribute('data-sub-collection-filters-aggregated');
        }

        updateFilterIndicator();

        if (typeof window.setActiveTabFromURL === 'function') {
          window.setActiveTabFromURL();
        }
      });

      closeDrawer();
    } catch (error) {
      console.error('Error applying filters:', error);
      requestAnimationFrame(() => {
        productGrids.forEach(productGrid => {
          productGrid.classList.remove('opacity-50', 'pointer-events-none');
        });
      });
    }
  }

  function clearFilters() {
    const filterCheckboxes = document.querySelectorAll('.filter-checkbox, .filter-checkbox-toggle');

    requestAnimationFrame(() => {
      filterCheckboxes.forEach(filterCheckbox => filterCheckbox.checked = false);

      // Clear size filter checkboxes
      const sizeFilterCheckboxes = document.querySelectorAll('.size-filter-checkbox');
      sizeFilterCheckboxes.forEach(sizeCheckbox => {
        sizeCheckbox.checked = false;
        const customCheckbox = sizeCheckbox.nextElementSibling;
        const checkIcon = customCheckbox?.querySelector('.size-filter-check');
        if (customCheckbox) {
          customCheckbox.classList.remove('border-black', 'bg-black');
          customCheckbox.classList.add('border-gray-300');
        }
        if (checkIcon) {
          checkIcon.classList.add('hidden');
        }
      });

      toggleSwitches.forEach(filterToggle => {
        const toggleSwitchElement = filterToggle.nextElementSibling;
        const toggleDot = toggleSwitchElement?.querySelector('.toggle-dot');
        if (toggleSwitchElement) {
          toggleSwitchElement.classList.remove('bg-black');
          toggleSwitchElement.classList.add('bg-gray-300');
        }
        if (toggleDot) {
          toggleDot.classList.remove('translate-x-5');
          toggleDot.classList.add('translate-x-0');
        }
      });

      colorFilterCheckboxes.forEach(colorCheckbox => {
        const colorSwatch = colorCheckbox.nextElementSibling;
        const swatchDot = colorSwatch?.querySelector('.swatch-color');
        if (colorSwatch) {
          colorSwatch.classList.remove('active');
        }
        if (swatchDot) {
          swatchDot.classList.remove('opacity-100');
          swatchDot.classList.add('opacity-0');
        }
      });

      document.querySelectorAll('.color-parent-swatch-checkbox').forEach(parentSwatch => {
        parentSwatch.checked = false;
        updateParentSwatchVisual(parentSwatch);
      });
    });

    const currentUrl = new URL(window.location.href);
    Array.from(currentUrl.searchParams.keys()).forEach(filterKey => {
      if (filterKey.startsWith('filter.') || filterKey === 'size_collections') {
        currentUrl.searchParams.delete(filterKey);
      }
    });

    lastFilterState = '';
    subCollectionFiltersAggregated = false;
    const filterContainer = document.querySelector('.filter-aggregated-content');
    if (filterContainer) {
      filterContainer.removeAttribute('data-sub-collection-filters-aggregated');
    }

    updateFilterIndicator();
    window.location.href = currentUrl.toString();
  }

  const applyButtons = document.querySelectorAll('.filter-apply-button');
  applyButtons.forEach(applyButton => {
    applyButton.addEventListener('click', (e) => {
      e.stopPropagation();
      applyFilters();
    });
  });

  const clearButtons = document.querySelectorAll('.filter-clear-button');
  clearButtons.forEach(clearButton => {
    clearButton.addEventListener('click', (e) => {
      e.stopPropagation();
      clearFilters();
    });
  });
});

